<template>
  <div v-if="!isMobile && isLogin" class="c-navbar__wrapper">
    <div class="p-navbar">
      <div class="nav_content jtf_between">
        <Menu />
        <!-- <div class="nav_right">
          <div class="nav_right-item">検索ヒット件数</div>
        </div> -->
      </div>
    </div>
    <!-- <div class="nav_breadcrumb">
      <div class="nav_left-item" v-for="(nav, i) of navBars" :key="i">
        {{ nav.title }}
        <img width="5" height="8.5" src="@/assets/images/arrow-right.svg" alt="icon" />
      </div>
    </div> -->
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();
const isMobile = computed(() => store.state.common.isMobile);
const isLogin = computed(() => store.state.auth.isLogin);

</script>

<style lang="scss" scoped>
.p-navbar {
  background-color: #04a4de;
  font-weight: 500;
  color: #ffffff;
  height: 60px;
  .nav_content {
    max-width: 1400px;
    height: 100%;
    margin: 0 auto;
    align-items: center;
    .nav_left,
    .nav_right {
      display: inline-flex;
      height: 100%;

      &-item {
        padding: 0 25px;
        display: inline-flex;
        align-items: center;
        cursor: pointer;
        &:first-child {
          background-color: #ffffffe3;
          color: #222222;
        }
        &:hover {
          background-color: #ffffffe3;
          color: #222222;
        }
      }
    }
    .nav_right {
      &-item {
        &:first-child {
          background-color: unset;
          color: #ffffff;
        }
      }
    }
  }
}
.nav_breadcrumb {
  max-width: 1400px;
  height: 60px;
  margin: 0 auto;
  align-items: center;
  display: flex;
  font-weight: 500;
  /* display:none; */
  .nav_left-item {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    color: #626262;
    img {
      margin: 0 8px;
    }
    &:last-child {
      color: #04a4de;
      img {
        display: none;
      }
    }
  }
}

@media screen and (max-width: 414px) {
  .p-navbar,
  .nav_breadcrumb {
    margin: 0 -10px;
  }
}
</style>
